import {
  WORK_ORDERS_DETAILS_NEW_TASK_ATTRIBUTE_CHANGE,
  WORK_ORDERS_DETAILS_NEW_TASK_FORM_CLEAR,
  WORK_ORDERS_DETAILS_NEW_TASK_IMAGE_REMOVE,
  WORK_ORDERS_DETAILS_NEW_TASK_MODAL_SHOW,
} from 'actions/admin/work-orders/action-types';
import { loadTradesRequest } from 'actions/admin/work-orders/details/details';
import { getForm } from 'selectors/admin/work-orders/details/new-task';
import { buildTaskName } from 'services/utils/text-util';
import { getFilesFromDataImages } from 'services/utils/images-util';

export function attributeChange(attribute, value, label) {
  return (dispatch, getState) => {
    const form = getForm(getState());
    if (attribute === 'images') {
      getFilesFromDataImages(value).then((imageFiles) => {
        const currentImages = form.images;
        dispatch(
          attributeChangeAction(attribute, currentImages.concat(imageFiles))
        );
      });
    } else {
      dispatch(attributeChangeAction(attribute, value));

      // Check if 'name' attribute should be updated
      if (attribute === 'trade') {
        updateName(dispatch, label);
      }
    }
  };
}

function attributeChangeAction(attribute, value) {
  return {
    type: WORK_ORDERS_DETAILS_NEW_TASK_ATTRIBUTE_CHANGE,
    payload: { attribute, value },
  };
}

export function clearForm() {
  return {
    type: WORK_ORDERS_DETAILS_NEW_TASK_FORM_CLEAR,
  };
}

export function openModal(loadTrades, lastTaskNumber) {
  return (dispatch) => {
    const newTaskNumber = lastTaskNumber + 1;
    if (loadTrades) {
      dispatch(loadTradesRequest()).then((response) => {
        if (response.ok) {
          openModalConfirm(dispatch, newTaskNumber);
        }
      });
    } else {
      openModalConfirm(dispatch, newTaskNumber);
    }
  };
}

function openModalConfirm(dispatch, newTaskNumber) {
  dispatch(clearForm());
  dispatch(attributeChange('number', newTaskNumber));
  dispatch(setShowModal(true));
}

export function removeImage(index) {
  return {
    type: WORK_ORDERS_DETAILS_NEW_TASK_IMAGE_REMOVE,
    payload: index,
  };
}

export function setShowModal(show) {
  return {
    type: WORK_ORDERS_DETAILS_NEW_TASK_MODAL_SHOW,
    payload: show,
  };
}

function updateName(dispatch, trade) {
  dispatch(attributeChangeAction('name', buildTaskName(trade)));
}



// WEBPACK FOOTER //
// ./src/actions/admin/work-orders/details/new-task.js